import {Basic, Ventrata} from 'types'
import {Screen} from 'types/basic'
import {twScreen} from 'utils/tailwind/twScreen'

export const MEDIA_QUERY = `(min-width: ${twScreen('d')})`
export const DEFAULT_SCREEN: Screen = window.matchMedia(MEDIA_QUERY).matches ? 'desktop' : 'mobile'

export const DEFAULT_CONTACT: Basic.Contact = {
  firstName: '',
  lastName: '',
  emailAddress: '',
  phoneNumber: '',
  allowMarketing: false,
  country: 'US',
}

export const ORDER_DETAILS_FORMAT_VERSION = 1

export const DEFAULT_ORDER_DETAILS: Basic.OrderDetails = {
  contact: DEFAULT_CONTACT,
  navigationHistory: [],
  activityDetails: {},
  cartState: DEFAULT_SCREEN === 'desktop' ? 'opened' : 'closed',
  crossSelling: {},
  paymentType: '',
  formatVersion: ORDER_DETAILS_FORMAT_VERSION,
}

export const DEFAULT_VENTRATA_CALEBDAR_DAY: Ventrata.CalendarDay = {
  localDate: '',
  available: false,
  status: 'CLOSED',
  vacancies: 0,
  capacity: 0,
  paxCount: 0,
  utcCutoffAt: '',
  availabilityLocalStartTimes: [],
}

export const DEFAULT_VENTRATA_AVAILABILITY: Ventrata.Availability = {
  localDateTimeStart: '',
  id: '',
}

export const DEFAULT_VENTRATA_PRODUCT: Ventrata.Product = {
  id: '',
  internalName: '',
  reference: '',
  options: [],
  locale: '',
  timeZone: '',
}

export const DEFAULT_VENTRATA_OPTION: Ventrata.Option = {
  id: '',
  default: false,
  internalName: '',
  reference: '',
  units: [],
  availabilityLocalStartTimes: [],
}

export const DEFAULT_VENTRATA_UNIT: Ventrata.Unit = {
  type: 'ADULT',
  id: '',
  internalName: '',
  reference: '',
  restrictions: {minAge: 0, maxAge: 0},
}

export const DATE_FORMAT = 'YYYY-MM-DD'
export const MONTH_FORMAT = 'YYYY-MM'
